<template>
  <TheGreyWrapper>
    <TheHeader
      with-cross
      force-sm-style
      @close="$router.push('/opportunities')"
    />

    <BaseSection>
      <div class="max-w-md">
        <BaseTitle
          :small="true"
          class="mb-4"
        >
          {{ $t('Profile validated') }}
        </BaseTitle>
        <BaseParagraph
          v-if="signed"
          class="mb-4"
        >
          {{ $t('Kyc Signed message') }}
        </BaseParagraph>
        <BaseParagraph
          v-if="cancelled"
          class="mb-4"
        >
          {{ $t('Kyc signing cancelled message') }}
        </BaseParagraph>
        <BaseButton
          :title="$t('Continue')"
          to="/opportunities"
          class="md:block"
        />
      </div>
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import { RESET_BANNER } from '../../store/mutation-types';
import TheHeader from '../../components/TheHeader.vue';
import BaseSection from '../../components/BaseSection.vue';
import BaseParagraph from '../../components/BaseParagraph.vue';
import BaseButton from '../../components/BaseButton.vue';
import BaseTitle from '../../components/BaseTitle.vue';
import TheGreyWrapper from '../../components/TheGreyWrapper.vue';

export default {
  name: 'Signed',
  components: {
    TheHeader,
    BaseSection,
    BaseParagraph,
    BaseButton,
    BaseTitle,
    TheGreyWrapper,
  },
  computed: {
    event() {
      return this.$route.query.event;
    },
    signed() {
      return this.event === 'signing_complete';
    },
    cancelled() {
      return this.event === 'cancel';
    },
  },
  created() {
    this.$store.commit(RESET_BANNER);
    this.sign();
  },
  methods: mapActions('kyc', ['sign']),
};
</script>
